import { createAuthClient } from 'better-auth/react'
import { emailOTPClient } from 'better-auth/client/plugins'

const apiBaseUrl = (import.meta.env.VITE_API_URL || '/api').replace(/\/$/, '')
const legacyLocalStorageKeys = ['auth_token', 'user', 'auth_session']
const legacySessionStorageKeys = ['auth_session', 'login_in_progress', 'auth_url', 'auth_state']

export function clearLegacyAuthStorage() {
  if (typeof window === 'undefined') {
    return
  }

  for (const key of legacyLocalStorageKeys) {
    window.localStorage.removeItem(key)
  }

  for (const key of legacySessionStorageKeys) {
    window.sessionStorage.removeItem(key)
  }
}

if (typeof window !== 'undefined') {
  clearLegacyAuthStorage()
}

export const authClient = createAuthClient({
  plugins: [emailOTPClient()],
})

export async function apiFetch(path: string, options: RequestInit = {}) {
  return fetch(`${apiBaseUrl}${path}`, {
    ...options,
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  })
}

export const authService = {
  sendLoginCode: async (email: string) => {
    const response = await fetch(`${apiBaseUrl}/auth/login-code`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    })

    if (!response.ok) {
      throw new Error('Failed to send login code')
    }
  },
  verifyLoginCode: async (email: string, otp: string) => authClient.signIn.emailOtp({
    email,
    otp,
  }),
  logout: async () => {
    try {
      await authClient.signOut()
    } finally {
      clearLegacyAuthStorage()
    }
  },
  apiRequest: apiFetch,
}
